// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { IoCloseOutline } from "react-icons/io5";
// import { PiChats } from "react-icons/pi";
// import { closeModal } from "../../features/modal/ModalSlice";
// import AgentSettingsWidget from "../Widget/AgentSettingsWidget";
// import OutBoundCallPopup from "./OutBoundCallPopup";
// import { PhoneCall } from "lucide-react";
// import toast from "react-hot-toast";

// const CommonCallForOutbondInbond = () => {
//   const dispatch = useDispatch();
//   const userInfo = useSelector((state) => state.userInfo.user);

//   const [number, setNumber] = useState("");
//   const [showKeypad, setShowKeypad] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [showTranscript, setShowTranscript] = useState(false); // ✅ Local state instead of Redux

//   const handleAddDigit = (digit) => {
//     setNumber((prev) => prev + digit);
//   };

//   const handleOutboundCall = async () => {
//     if (!number) {
//       toast.error("Please enter a number to call");
//       return;
//     }

//     const payload = {
//       caller: "+911203214860",
//       destination: `+91${number}`,
//       country: "in",
//     };

//     try {
//       setLoading(true);
//       const res = await fetch(
//         `https://voipaiagent-api.greymatterz.com/api/v1/customoutbound`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );
//       const data = await res.json();
//       toast.success(data?.message || "Call initiated successfully!");
//       console.log("📞 Outbound Call:", payload);
//     } catch (error) {
//       console.error("Call Error:", error);
//       toast.error("Failed to initiate call");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClosePopup = () => dispatch(closeModal());

//   const dialButtons = [
//     ["1", " "],
//     ["2", "ABC"],
//     ["3", "DEF"],
//     ["4", "GHI"],
//     ["5", "JKL"],
//     ["6", "MNO"],
//     ["7", "PQRS"],
//     ["8", "TUV"],
//     ["9", "WXYZ"],
//     ["*", ""],
//     ["0", "+"],
//     ["#", ""],
//   ];

//   return (
//     <div className="rightModal taskModal">
//       <div className="modal-header p-3">
//         <h4 className="m-0">Call</h4>
//         <button className="btnClose ms-auto" onClick={handleClosePopup}>
//           <IoCloseOutline />
//         </button>
//       </div>

//       <div className="p-4 dialBox" style={{ display: "flex", gap: "1rem" }}>
//         {/* LEFT SECTION */}
//         <div style={{ flex: 1 }}>
//           <div className="mb-1 d-flex justify-content-between align-items-center">
//             <button
//               className={`activitieBtn ${
//                 showTranscript ? "activeActivity" : ""
//               }`}
//               onClick={() => setShowTranscript((prev) => !prev)} // ✅ local toggle
//               title="Show Transcript"
//             >
//               <span className="me-2">
//                 <PiChats />
//               </span>
//               Transcript
//             </button>

//             {userInfo?.is_demo_account && <AgentSettingsWidget />}
//           </div>

//           <div style={{ textAlign: "center", marginBottom: "1rem" }}>
//             <label
//               style={{
//                 display: "block",
//                 fontSize: "0.85rem",
//                 color: "#444",
//                 marginBottom: "0.25rem",
//               }}
//             >
//               Phone number
//             </label>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "8px",
//               }}
//             >
//               <input
//                 type="text"
//                 value={number}
//                 onChange={(e) => setNumber(e.target.value)}
//                 style={{
//                   border: "none",
//                   borderBottom: "1px solid #ccc",
//                   outline: "none",
//                   textAlign: "center",
//                   fontSize: "1.1rem",
//                   width: "200px",
//                 }}
//               />
//               <button
//                 onClick={handleOutboundCall}
//                 disabled={loading}
//                 style={{
//                   border: "none",
//                   background: "transparent",
//                   cursor: "pointer",
//                 }}
//                 title="Call"
//               >
//                 <PhoneCall
//                   size={22}
//                   color={loading ? "#999" : "#007bff"}
//                   strokeWidth={2}
//                 />
//               </button>
//             </div>
//           </div>

//           {/* Dialpad */}
//           {showKeypad && (
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(3, 1fr)",
//                 gap: "10px",
//                 justifyItems: "center",
//                 maxWidth: "250px",
//                 margin: "0 auto",
//               }}
//             >
//               {dialButtons.map(([num, letters]) => (
//                 <button
//                   key={num}
//                   onClick={() => handleAddDigit(num)}
//                   style={{
//                     background: "transparent",
//                     border: "none",
//                     textAlign: "center",
//                     cursor: "pointer",
//                     padding: "10px",
//                   }}
//                 >
//                   <div style={{ fontSize: "1.5rem", fontWeight: "500" }}>
//                     {num}
//                   </div>
//                   <div
//                     style={{
//                       fontSize: "0.8rem",
//                       color: "#555",
//                       lineHeight: "1",
//                     }}
//                   >
//                     {letters}
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}

//           <div
//             style={{
//               textAlign: "center",
//               marginTop: "10px",
//               color: "#4a3aff",
//               cursor: "pointer",
//               fontSize: "0.9rem",
//             }}
//             onClick={() => setShowKeypad(!showKeypad)}
//           >
//             {showKeypad ? "Hide keypad" : "Show keypad"}
//           </div>
//         </div>

//         {/* RIGHT SECTION (TRANSCRIPT) */}
//         {showTranscript && (
//           <div
//             style={{
//               flex: 1,
//               borderLeft: "1px solid #ddd",
//               paddingLeft: "1rem",
//               maxHeight: "75vh",
//               overflowY: "auto",
//             }}
//           >
//             <OutBoundCallPopup />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CommonCallForOutbondInbond;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoCloseOutline } from "react-icons/io5";
import { PiChats } from "react-icons/pi";
import { closeModal } from "../../features/modal/ModalSlice";
import AgentSettingsWidget from "../Widget/AgentSettingsWidget";
import OutBoundCallPopup from "./OutBoundCallPopup";
import { Phone, PhoneCall, PhoneOff } from "lucide-react";
import toast from "react-hot-toast";

const CommonCallForOutbondInbond = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo.user);

  const [number, setNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [showKeypad, setShowKeypad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [callActive, setCallActive] = useState(false);
  const [showTranscript, setShowTranscript] = useState(false);

  const handleAddDigit = (digit) => {
    setNumber((prev) => prev + digit);
  };

  const handleClosePopup = () => dispatch(closeModal());

  const handleOutboundCall = async () => {
    if (!number) {
      toast.error("Please enter a number to call");
      return;
    }

    const payload = {
      caller: "+911203214860",
      destination: `${countryCode}${number}`,
      country: countryCode === "+1" ? "us" : "in",
      source: "tryout",
    };

    try {
      setLoading(true);
      const res = await fetch(`https://voipaiagent-api.greymatterz.com/api/v1/customoutbound`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data) {
        setShowTranscript(true);
        toast.success(data?.message || "Call initiated successfully!");
        console.log("📞 Outbound Call:", payload);
        // setCallActive(true); // ✅ Mark call as active
      }
    } catch (error) {
      console.error("Call Error:", error);
      toast.error("Failed to initiate call");
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnectCall = () => {
    setCallActive(false);
    toast("Call disconnected", { icon: "📴" });
  };

  const dialButtons = [
    ["1", " "],
    ["2", "ABC"],
    ["3", "DEF"],
    ["4", "GHI"],
    ["5", "JKL"],
    ["6", "MNO"],
    ["7", "PQRS"],
    ["8", "TUV"],
    ["9", "WXYZ"],
    ["*", ""],
    ["0", "+"],
    ["#", ""],
  ];

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">Call</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4 dialBox" style={{ display: "flex", gap: "1rem" }}>
        {/* LEFT SECTION */}
        <div style={{ flex: 1 }}>
          <div className="mb-1 d-flex justify-content-between align-items-center">
            <button
              className={`activitieBtn ${showTranscript ? "activeActivity" : ""}`}
              onClick={() => setShowTranscript((prev) => !prev)}
              title="Show Transcript"
            >
              <span className="me-2">
                <PiChats />
              </span>
              Activities
            </button>

            {userInfo?.is_demo_account && <AgentSettingsWidget />}
          </div>

          {/* Country and Number Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: "1rem",
            }}
            className="mt-5"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
              }}
            >
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                style={{
                  padding: "6px 8px",
                  fontSize: "0.95rem",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  outline: "none",
                  cursor: "pointer",
                }}
              >
                <option value="+91">🇮🇳 +91</option>
                <option value="+1">🇺🇸 +1</option>
              </select>

              <input
                type="text"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                placeholder="Enter number"
                style={{
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  outline: "none",
                  textAlign: "center",
                  fontSize: "1.1rem",
                  width: "180px",
                }}
              />

              {!callActive ? (
                <button
                  onClick={handleOutboundCall}
                  disabled={loading}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                  }}
                  title="Call"
                >
                  <Phone />
                  {/* <PhoneCall
                    size={22}
                    color={loading ? "#999" : "#007bff"}
                    strokeWidth={2}
                  /> */}
                </button>
              ) : (
                <button
                  onClick={handleDisconnectCall}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                  }}
                  title="Disconnect"
                >
                  <PhoneOff size={22} color="#dc3545" strokeWidth={2} />
                </button>
              )}
            </div>
          </div>

          {/* Dialpad */}
          {!callActive && showKeypad && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "10px",
                justifyItems: "center",
                maxWidth: "250px",
                margin: "0 auto",
              }}
              className="mt-3"
            >
              {dialButtons.map(([num, letters]) => (
                <button
                  key={num}
                  onClick={() => handleAddDigit(num)}
                  style={{
                    background: "transparent",
                    border: "none",
                    textAlign: "center",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                >
                  <div style={{ fontSize: "1.5rem", fontWeight: "500" }}>{num}</div>
                  <div
                    style={{
                      fontSize: "0.8rem",
                      color: "#555",
                      lineHeight: "1",
                    }}
                  >
                    {letters}
                  </div>
                </button>
              ))}
            </div>
          )}

          {!callActive && (
            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
                color: "#4a3aff",
                cursor: "pointer",
                fontSize: "0.9rem",
              }}
              onClick={() => setShowKeypad(!showKeypad)}
            >
              {showKeypad ? "Hide keypad" : "Show keypad"}
            </div>
          )}

          {callActive && (
            <div
              style={{
                textAlign: "center",
                marginTop: "1.5rem",
                fontSize: "0.95rem",
                color: "#198754",
                fontWeight: 500,
              }}
            >
              Connected to {countryCode} {number}
            </div>
          )}
        </div>

        {/* RIGHT SECTION (TRANSCRIPT) */}
        {showTranscript && (
          <div
            style={{
              flex: 1,
              borderLeft: "1px solid #ddd",
              paddingLeft: "1rem",
              maxHeight: "75vh",
              overflowY: "auto",
            }}
          >
            <OutBoundCallPopup />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonCallForOutbondInbond;
